import { createTheme } from '@mui/material/styles'

import { components } from './components'
import { colours, layout } from './tokens'
import { typography } from './typography'

// Desktop dashboard theme. Users are on managed Chromebooks; do not add
// mobile breakpoints or responsive typography variants.
const theme = createTheme({
  // Enabling CSS variables should not alter the design, but leave this disabled until
  // the remaining styled-components have been checked against the generated variables.
  // cssVariables: true,
  palette: {
    primary: {
      main: colours.teal,
      dark: colours.darkTeal,
      contrastText: colours.white,
      // Navy meets WCAG AA on teal, but changing this would alter existing buttons.
      // contrastText: colours.blue,
    },
    secondary: {
      main: colours.blue,
      contrastText: colours.white,
    },
    error: {
      main: colours.red,
    },
    warning: {
      main: colours.orange,
      light: colours.lightOrange,
    },
    info: {
      main: colours.link,
    },
    success: {
      main: colours.teal,
    },
    text: {
      primary: colours.blue,
      secondary: colours.lightGray,
      disabled: colours.darkGrey,
    },
    divider: 'rgba(188, 190, 192, 0.5)',
    background: {
      default: colours.white,
      paper: colours.white,
    },
    action: {
      hover: colours.hoverGrey,
      disabled: colours.darkGrey,
      disabledBackground: colours.lightGrey,
    },
    common: {
      black: colours.black,
      white: colours.white,
    },
  },
  typography,
  shape: {
    borderRadius: 5,
  },
  colours,
  layout,
  components,
})

export const defaultGridSpacing = theme.layout.defaultGridSpacing

export default theme
